module.exports = __webpack_public_path__ + "media/images/abacus-carbono-white-0bb53a62.png";